var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_82",
    "data-name": "Layer 82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.14,28.52a1.51,1.51,0,0,0,1.92.84l9.49-3.63a1.5,1.5,0,0,0-1.07-2.8l-6.41,2.45c7-14.79,28.85-12.93,33.16,3a1.5,1.5,0,0,0,2.9-.78c-5-18.42-30.2-20.78-38.61-3.81l-2.23-5.83A1.5,1.5,0,0,0,8.49,19S12.1,28.49,12.14,28.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.51,44.44,52.09,35.5a1.59,1.59,0,0,0-.45-.61,1.51,1.51,0,0,0-1.49-.25l-8.94,3.42a1.5,1.5,0,0,0,1.07,2.8l5.86-2.24c-7,14.79-28.85,12.93-33.17-3a1.5,1.5,0,0,0-1.83-1.06,1.52,1.52,0,0,0-1.07,1.84c5,18.42,30.21,20.78,38.61,3.8l2,5.29A1.5,1.5,0,0,0,55.51,44.44Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.89536ce7.svg";
export { ForwardRef as ReactComponent };